import { Component, OnInit, ViewChild } from "@angular/core";
import { BusMainMapComponent } from "./bus-main-map/bus-main-map.component";

@Component({
	selector: "app-bus-tracker-main-map",
	templateUrl: "./bus-tracker-main-map.component.html",
	styleUrls: ["./bus-tracker-main-map.component.css"],
})
export class BusTrackerMainMapComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}

	///////////////////////////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////////////////////////

	@ViewChild(BusMainMapComponent)
	mapRef: BusMainMapComponent;

	SchoolAlertsExpand: any = false;
	BusAlertsExpand: any = true;
	GeoFenceAlertsExpand: any = true;
	///////////////////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////////////////////////////////////

	onRefresh() {
		this.mapRef.onRefresh();
	}

	///////////////////////////////////////////////////////////////////////////////////////
}
